import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function BenefitsSection() {
  const handleCTAClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackAddToCart();
    window.location.href = 'https://tejeyemprende.store/cart/add?id=52432487153961&quantity=1';
  };
  const benefits = [<>
      Crear tu primera pieza en <b data-id="element-1">menos de 24 horas</b>
    </>, <>
      Seguir un proceso claro <u data-id="element-2">sin perderte</u>
    </>, <>Dejar de depender de tutoriales confusos</>, <>
      Tener <i data-id="element-3">ideas infinitas</i> para tejer
    </>, <>
      Convertir esto en una <b data-id="element-4">fuente de ingresos desde casa</b>
    </>];
  return <section className="w-full py-24 px-4 bg-secondary/20" data-id="element-5">
      <div className="max-w-5xl mx-auto" data-id="element-6">
        <h2 className="font-heading font-bold text-3xl md:text-5xl text-center text-textDark mb-16" data-id="element-7">
          Con este método vas a poder:
        </h2>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-8">
          {benefits.map((benefit, index) => <div key={index} className={`flex items-start gap-5 p-8 bg-white rounded-3xl shadow-soft border border-secondary/30 transition-all duration-300 hover:shadow-soft-lg hover:-translate-y-1 ${index === benefits.length - 1 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-9">
              <div className="bg-success/10 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-10">
                <CheckCircleIcon className="w-7 h-7 text-success" aria-hidden="true" data-id="element-11" />
              </div>
              <p className="font-body text-lg md:text-xl text-textDark leading-relaxed" data-id="element-12">
                {benefit}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-13">
          <a href="https://tejeyemprende.store/cart/add?id=52432487153961&quantity=1" onClick={handleCTAClick} className="inline-block w-full sm:w-auto bg-primary hover:bg-primary/90 text-white font-body font-bold text-lg px-12 py-5 rounded-full shadow-soft-lg transition-all duration-300 transform hover:-translate-y-1" data-id="element-14">
            SÍ, QUIERO APRENDER
          </a>
        </div>
      </div>
    </section>;
}